document.addEventListener('DOMContentLoaded', function () {
	const sortButtons = document.querySelectorAll('.sort-option');
	const summary = document.querySelector('.filter-dropdown summary');

	if (sortButtons) {
		sortButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				const selectedValue = this.getAttribute('data-value');
				const queryParams = new URLSearchParams(window.location.search);
				let selectedText = '';

				switch (selectedValue) {
					case 'date_desc':
						queryParams.set('orderby', 'date');
						queryParams.set('order', 'DESC');
						selectedText = this.textContent; // "Newest"
						break;
					case 'date_asc':
						queryParams.set('orderby', 'date');
						queryParams.set('order', 'ASC');
						selectedText = this.textContent; // "Older"
						break;
				}

				// Atualize o texto do summary com o valor selecionado.
				if (summary && selectedText) {
					summary.textContent = selectedText;
				}

				// Redirecione para a nova URL com os parâmetros atualizados.
				window.location.search = queryParams.toString();
			});
		});
	}
});
